import { marked } from 'marked';

marked.setOptions({
	breaks: true,
	gfm: true,
	headerIds: false,
	mangle: false,
});

function escapeHtml(value) {
	return String(value)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

export function renderMarkdown(text) {
	if (!text) {
		return '';
	}

	try {
		return marked.parse(escapeHtml(text));
	} catch (error) {
		window.console.warn('Falha ao renderizar markdown:', error);
		return escapeHtml(text).replace(/\n/g, '<br>');
	}
}
